module.exports = __webpack_public_path__ + "img/1787895894733852673.22cd0054.png";